@if (notice; as n) {
  <!-- Same overlay as every other dialog in the app, above whatever raised it. -->
  <div class="fixed inset-0 z-[60] flex items-start sm:items-center justify-center p-4 overflow-y-auto bg-black/50 backdrop-blur-sm">
    <div #panel role="alertdialog" aria-modal="true" aria-labelledby="plan-limit-title" aria-describedby="plan-limit-message"
      tabindex="-1" class="w-full max-w-md bg-surface rounded-card shadow-overlay border border-borderLight my-auto outline-none">

      <div class="px-6 pt-6 pb-4 flex items-start gap-4">
        <div class="w-10 h-10 rounded-full bg-red-50 border border-red-100 flex items-center justify-center shrink-0">
          <lucide-icon [img]="AlertTriangle" class="w-5 h-5 text-red-600"></lucide-icon>
        </div>
        <div class="min-w-0 flex-1">
          <h2 id="plan-limit-title" class="text-lg font-semibold text-slateText">
            {{ ('planNotice.title.' + kind) | transloco }}
          </h2>
          <p id="plan-limit-message" class="text-sm text-slateText mt-1">{{ n.message }}</p>
        </div>
        <button type="button" (click)="close()" [attr.aria-label]="'common.close' | transloco"
          class="text-mutedText hover:text-slateText p-1 rounded-control hover:bg-gray-100 transition-colors shrink-0">
          <lucide-icon [img]="X" class="w-5 h-5"></lucide-icon>
        </button>
      </div>

      @if (kind === 'limit' && n.limit !== undefined && n.kind) {
        <div class="px-6 pb-4">
          <div class="flex items-center justify-between text-sm">
            <span class="text-mutedText">{{ ('plans.limit.' + n.kind) | transloco }}</span>
            <span class="font-semibold text-destructive tabular-nums">
              {{ 'schoolPlan.used' | transloco: { used: n.used ?? 0, limit: n.limit } }}
            </span>
          </div>
          <div class="mt-1.5 h-2 rounded-full bg-gray-100 overflow-hidden">
            <div class="h-full rounded-full bg-destructive" [style.width.%]="percent"></div>
          </div>
        </div>
      }

      <div class="mx-6 mb-5 p-4 rounded-card bg-indigo-50 border border-indigo-100">
        <p class="text-sm font-semibold text-primary flex items-start gap-2">
          <lucide-icon [img]="ArrowUpRight" class="w-4 h-4 shrink-0 mt-0.5"></lucide-icon>
          {{ ('planNotice.upgrade.' + (n.kind ?? kind)) | transloco }}
        </p>
        <p class="text-sm text-slateText mt-1.5">
          @if (canChangePlan) {
            {{ 'planNotice.howPlatform' | transloco }}
          } @else if (supportEmail) {
            {{ 'planNotice.howEmail' | transloco }}
            <a [href]="'mailto:' + supportEmail" class="font-semibold text-primary hover:underline inline-flex items-center gap-1">
              <lucide-icon [img]="Mail" class="w-3.5 h-3.5"></lucide-icon>{{ supportEmail }}
            </a>
          } @else {
            {{ 'planNotice.howSupport' | transloco }}
          }
        </p>
      </div>

      <div class="px-6 py-4 border-t border-borderLight flex flex-wrap items-center justify-end gap-2">
        @if (canChangePlan || canSeePlan) {
          <button type="button" class="kai-btn-ghost" (click)="viewPlan()">
            {{ (canChangePlan ? 'planNotice.changePlan' : 'planNotice.viewPlan') | transloco }}
          </button>
        }
        <button type="button" class="kai-btn-primary" (click)="close()">{{ 'planNotice.ok' | transloco }}</button>
      </div>
    </div>
  </div>
}
